import { useTranslation } from 'react-i18next';

import { Drawer } from '@/components/Drawer';
import { useDrawer } from '@/components/Drawer/context/useDrawer';

const drawerContent: Record<string, { titleKey: string; descriptionKey: string }> = {
  notifications: {
    titleKey: 'notifications.title',
    descriptionKey: 'notifications.description',
  },
};

export function DrawerManager() {
  const { t } = useTranslation();
  const { activeDrawer, closeDrawer } = useDrawer();

  if (!activeDrawer) {
    return null;
  }

  const content = drawerContent[activeDrawer];

  if (!content) {
    return null;
  }

  return (
    <Drawer
      open={Boolean(activeDrawer)}
      onOpenChange={(open) => {
        if (!open) {
          closeDrawer();
        }
      }}
      title={t(content.titleKey)}
      description={t(content.descriptionKey)}
    >
      <article className="surface-card surface-card--soft">
        <h3>{t('notifications.emptyTitle')}</h3>
        <p>{t('notifications.emptyBody')}</p>
      </article>
    </Drawer>
  );
}
